import {Field, ErrorMessage} from 'formik';
import styled from 'styled-components';

import {
  TextFieldContainer,
  FieldMargin,
} from '../../_old/FieldHelpers/FieldContainers';
import {FormError} from '../../_old/FieldHelpers/FormError';
import {Label} from '../../_old/FieldHelpers/Label';

import type {FieldInputProps, FieldProps} from 'formik';

export type TextInnerProps = React.InputHTMLAttributes<HTMLInputElement> & {
  field: FieldInputProps<any>;
  setIsActive: (b: boolean) => void;
};
export function TextInner({setIsActive, ...props}: TextInnerProps) {
  return (
    <StyledInput
      type="text"
      {...props.field}
      id={props.field.name}
      {...props}
      onBlur={() => setIsActive(false)}
      onFocus={() => setIsActive(true)}
    />
  );
}
const StyledInput = styled.input`
  border: none;
  width: 100%;
  background-color: transparent;
  outline: 0;

  &:focus {
    outline: 0;
    border: 0;
    box-shadow: none;
  }
`;

export type TextFieldProps = {
  name: string;
  children: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
};
export function TextField(props: TextFieldProps) {
  return (
    <FieldMargin>
      <Field name={props.name}>
        {({field, meta}: FieldProps) => (
          <TextFieldContainer
            readOnly={props.inputProps?.readOnly ?? false}
            error={meta.error}
          >
            {(isActive: boolean, setIsActive: (b: boolean) => void) => (
              <>
                <Label
                  isActive={isActive}
                  readOnly={props.inputProps?.readOnly ?? false}
                  error={meta.error}
                  required={props.inputProps?.required ?? false}
                  htmlFor={field.name}
                >
                  {props.children}
                </Label>
                <TextInner
                  field={field}
                  setIsActive={setIsActive}
                  {...props.inputProps}
                />
              </>
            )}
          </TextFieldContainer>
        )}
      </Field>
      <ErrorMessage name={props.name} component={FormError} />
    </FieldMargin>
  );
}
export function TextField2(props: TextFieldProps) {
  return (
    <FieldMargin>
      <Field name={props.name}>
        {({field, meta}: FieldProps) => (
          <>
            <TextFieldContainer
              readOnly={props.inputProps?.readOnly ?? false}
              error={meta.error}
            >
              {(isActive: boolean, setIsActive: (b: boolean) => void) => (
                <>
                  <Label
                    isActive={isActive}
                    readOnly={props.inputProps?.readOnly ?? false}
                    error={meta.error}
                    required={props.inputProps?.required ?? false}
                    htmlFor={field.name}
                  >
                    {props.children}
                  </Label>
                  <TextInner
                    field={field}
                    setIsActive={setIsActive}
                    {...props.inputProps}
                  />
                </>
              )}
            </TextFieldContainer>

            {meta.error &&
              meta.touched &&
              // @ts-expect-error formik zod not sure idk
              meta.error._errors?.map((error) => (
                <FormError key={error}>{error}</FormError>
              ))}
          </>
        )}
      </Field>
    </FieldMargin>
  );
}
